translations.inject$ = ['$translateProvider'];

export default function translations($translateProvider) {
    $translateProvider.translations('en', {
        browse__backToAllProducts: 'All Products',
        filter__compare: 'Compare',
        filter__compareSearch: 'Compare Search',
        filter__detection: 'Detected {{ parameter }} of {{ unknownValue }}.',
        filter__example: 'Example values: ',
        filter__noResults: 'No Results',
        filter__resetFilters: 'Reset Filters',
        label__alt_parts: 'Alternate Parts',
        label__action_close: 'Close',
        label__action_filter: 'Filter',
        label__availability: '{{ countOf }} Inventory Available',
        label__availability__region: 'Viewing Distributor Availability for',
        label__builder__technology: 'Filter this Technology',
        label__country: 'Country',
        label__cta__addPart: 'Add Part to Compare',
        label__cta__addSearch: 'Add Search to Compare',
        label__cta__altParts: 'View Alternate Parts',
        label__cta__backToDefinition: 'Back to {{ definition }}',
        label__cta__back: 'Back',
        label__cta__buy: 'Buy Now',
        label__cta__collapsible: '{{ collapseOrExpand }} Details',
        label__cta__collapseButton: 'Collapse',
        label__cta__copy: 'Copy Link',
        label__cta__expandButton: 'Expand',
        label__cta__viewDetails: 'View Details & Pricing',
        label__cta__viewPricing: 'View Pricing',
        label__distributor__pricing: '{{ distributor }}\'s Pricing',
        label__external__requestSamples: 'Request Samples for this part',
        label__external__requestSamplesFor: 'Request Samples for {{ partNumber }}',
        label__imageDisclaimer: 'Image for reference only.',
        label__inventory: '<strong>{{ numberOf }}</strong> Inventory Available',
        label__inventory__big: '<span class="h5">{{ numberOf }}</span> Inventory available',
        label__kit: '{{ numberOf }} Kit',
        label__kits: '{{ numberOf }} Kits',
        label__total__inventory: '<strong>{{ numberOf }} Total</strong> Inventory Available',
        label__loading__waiting: 'Please Wait...',
        label__loading__parts: 'Loading Parts, please wait...',
        label__negation: 'No',
        label__options: 'Options',
        label__part: '{{ numberOf }} Part',
        label__parts: '{{ numberOf }} Parts',
        label__placeholder_filter: 'Filter {{ someParameter}}',
        label__plotting__cv_title: 'Capacitance vs. Max Voltage',
        label__plotting__cv_x_axis: 'Capacitance (F)',
        label__plotting__cv_y_axis: 'Max Voltage (VDC)',
        label__price: 'Price',
        label__region: 'Region',
        label__required__octopartDisclaim: 'Pricing and Availability Powered by',
        label__search: 'Compare Search',
        label__seriesSelect__action: 'Select a Series',
        label__seriesSelect__prompt: 'Filter Series',
        label__seriesDatasheet: 'Series Datasheet',
        label__seriesDatasheet__empty_prompt: 'Select Series to Download Datasheet',
        label__seriesDatasheet__download_prompt: 'Download',
        label__seriesDatasheet__unavailable: 'Unavailable',
        label__similarProducts: 'Similar Products',
        label__sort: 'Sort',
        label__sort__option1__highest: 'Highest Price',
        label__sort__option2__lowest: 'Lowest Price',
        label__sort__option3__stock: 'Amount in Stock',
        label__tooltip__1__emphasis: 'Our new search is more powerful than ever!',
        label__tooltip__1__description: 'You can describe what you need however you want - even by competitor part number!',
        label__tooltip__2__emphasis: 'Compare parameters and more!',
        label__tooltip__2__description: 'With our new tool, you can easily see the differences between two parts.',
        label__tooltip__3__emphasis: 'Search by descriptions!',
        label__tooltip__3__description: 'Don\'t quite know what to search for but know how to describe it? Type it in the search box.',
        label__quantity: 'Quantity',
        label__queue__add: 'Add another product',
        message__alert__alreadySelected: 'You have already selected this value: {{ value }}.',
        message__changeToPart: 'There has been a change made to your Part Number. You searched for <b>{{ originalPart }}</b> and we changed it to <b>{{ changedPart }}</b>.',
        message__changeToParts: 'There has been a change made to your top result. You searched for <b>{{ originalPart }}</b> and the top result was <b>{{ changedPart }}</b>.',
        message__comparison__confirmation: 'Are you sure you want to delete this comparison? You can\'t compare only one item, so we\'ll go back to the previous screen.',
        message__defaultText: 'We\'ve found results matching your query.',
        message__errorText: 'We were unable to find any products matching your search.',
        message__findingAvailability: 'Finding availability...',
        message__header__info: 'Note',
        message__header__error: 'Uh Oh!',
        message__header__default: 'Heads Up!',
        message__MODIFIED: 'This part contains specification changes.',
        message__MODIFIED__NON_QUALIFIED: '<strong>Tip:</strong> You can compare your search against a result using the "Compare Search" checkbox.',
        message__NON_QUALIFIED: 'This part is not a fit/form/function match.',
        message__noAvailability: 'Currently, there is no availability or pricing for this part.',
        message__obsolete__nnd: 'Not for New Design',
        message__obsolete: 'Obsolete',
        message__overSelection: 'Can not select more than 3 items',
        message__plotting__data_error: 'Failed to retrieve data for plotting',
        message__server__rate_limit: 'Your rate limit has been exceeded, please try back again after 5 minutes.',
        message__server__generic: 'Something went wrong with the server.',
        modal__bad_browser__confirm: 'I Understand, let me continue.',
        modal__bad_browser__heading_red: 'Warning:',
        modal__bad_browser__heading: 'Unsupported Browser',
        modal__bad_browser__message: 'The browser you are using is not fully supported by this application, or there are significant performance issues.',
        modal__bad_browser__message__lte_IE_8: 'If you\'re using Internet Explorer 10 and seeing this message, you may be in compatibility mode. Please contact Support with any questions.',
        modal__bad_browser__message__download: 'If you\'re able to upgrade or switch to a modern browser, this will provide a much better experience. You can either click one of the below logos for their prospective download pages, or if you already have one of them installed, you can switch to that browser and it should work. Thank you.',
        nav__item__about: 'About KEMET',
        nav__item__buy: 'How to Buy',
        nav__item__ec: 'Engineering Center',
        nav__item__home: 'Home',
        nav__item__privacy: 'Privacy Policy',
        nav__item__do_not_sell: 'Cookie Settings',
        nav__item__products: 'Products',
        nav__item__search: 'Search Components',
        nav__item__service: 'Service & Support',
        nav__item__software: 'Third Party Software',
        nav__copyright: `Copyright &copy; ${(new Date().getFullYear())} KEMET. All rights Reserved.`,
        new__label: 'New!',
        plotting__cv_intro_header: 'Try Visual Search',
        plotting__cv_intro_message: 'This visualization represents the Capacitance and Max Voltage ranges each product category offers.',
        plotting__cv_instruction_header: 'How to use Visual Search',
        plotting__cv_instruction_message_pre: 'Here are some ways to use Visual Search:',
        plotting__cv_instruction_message_1: 'Toggle the product category names on the right to hide/show the product category data you want to see.',
        plotting__cv_instruction_message_2: 'Within the colorized visual area representing a product category\'s data, you can click on a data point to find all the parts with that Capacitance and Max Voltage.',
        plotting__cv_instruction_message_3: 'To zoom in on the data, click and drag a box around an area on the graph.',
        plotting__cv_instruction_message_4: 'The tool bar above the visualization allows you to zoom, move, reset, and download the graph as a .png image.',
        plotting__cv_instruction_message_5: 'Hovering over the graph displays the Capacitance and Max Voltage data points closest to your mouse.',
        search__label: 'Main Search',
        search__placeholder: 'Enter a KEMET/Competitor Part Number or Description',
        // -- OPTIONAL - This can be anchor title attributes and image alt tags, and others. Not necessary for launch [03-15-2018 talked to Tim].
        title__GoBackToHome: 'Go Back to Home',
        title__card__viewCategory: 'View the category under {{ thisDefinitionName }}',
        title__logo__title: 'KEMET Home',
        title__logo__alt: 'The KEMET Logo',
        title__heading__compare: 'Comparing {{ numberOf }} parts',
        visual__search__label: 'Visual Search',
        visualize__label: 'Visualize',
        wizard__home: 'Start Here',
        wizard__home2: 'Home',
        wizard__browse: 'Browse',
        wizard__viewParts: 'View Parts',
        wizard__buyParts: 'Buy Parts'
    });
    $translateProvider.translations('jp', {
        browse__backToAllProducts: '全ての製品',
        filter__compare: '比較する',
        filter__compareSearch: '比較して検索する',
        filter__detection: '{{ unknownValue }}の {{ parameter }} で検索しました.',
        filter__example: '記入例: ',
        filter__noResults: '該当なし',
        filter__resetFilters: '検索条件をリセット',
        label__alt_parts: '代替製品',
        label__action_close: 'ウィンドウを閉じる',
        label__action_filter: 'を選択してください',
        label__availability: '{{ countOf }}在庫状況',
        label__availability__region: '購入可能な販売店を見る',
        label__builder__technology: 'この製品群から検索',
        label__country: '国',
        label__cta__addPart: '他の製品と比較する',
        label__cta__addSearch: '検索条件を追加する',
        label__cta__altParts: '代替製品を見る',
        label__cta__backToDefinition: '戻る {{ definition }}',
        label__cta__back: '戻る',
        label__cta__buy: '購入する',
        label__cta__collapsible: '{{ collapseOrExpand }}をスマートフォンで見る',
        label__cta__collapseButton: '崩壊',
        label__cta__copy: 'リンクをコピー',
        label__cta__expandButton: '表示する',
        label__cta__viewDetails: '製品詳細と価格を見る',
        label__cta__viewPricing: '販売価格',
        label__distributor__pricing: '{{ distributor }}の価格',
        label__external__requestSamples: 'この製品のサンプルを要求する',
        label__external__requestSamplesFor: '{{ partNumber }}のサンプルを要求する',
        label__imageDisclaimer: '画像は代表例です。',
        label__inventory: '在庫数<strong>{{ numberOf }}</strong>',
        label__inventory__big: '在庫数<span class="h5">{{ numberOf }}</span>',
        label__kit: '{{ numberOf }}製品',
        label__kits: '{{ numberOf }}製品',
        label__total__inventory: '総在庫数<strong>{{ numberOf }}</strong>',
        label__loading__waiting: 'しばらくお待ちください',
        label__loading__parts: '製品情報を読み込んでます、しばらく待ち下さい...',
        label__negation: 'ありません',
        label__options: '選択',
        label__part: '{{ numberOf }}製品',
        label__parts: '{{ numberOf }}製品',
        label__placeholder_filter: '{{ someParameter}}を選択してください',
        label__plotting__cv_title: '静電容量 vs. 最大電圧',
        label__plotting__cv_x_axis: '静電容量 (F)',
        label__plotting__cv_y_axis: '最大電圧 (VDC)',
        label__price: '価格',
        label__region: '地域',
        label__required__octopartDisclaim: '価格と提供状況',
        label__search: '比較検索',
        label__seriesSelect__action: '製品シリーズを選択',
        label__seriesSelect__prompt: 'シリーズを選択してください',
        label__seriesDatasheet: 'シリーズ毎のデータシート',
        label__seriesDatasheet__empty_prompt: 'ダウンロードする製品シリーズを選択してください',
        label__seriesDatasheet__download_prompt: 'ダウンロード',
        label__seriesDatasheet__unavailable: 'データシートはありません',
        label__similarProducts: '類似製品',
        label__sort: 'ならび変える',
        label__sort__option1__highest: '価格の高い順',
        label__sort__option2__lowest: '価格の安い順',
        label__sort__option3__stock: '在庫数量',
        label__tooltip__1__emphasis: '検索方法がより便利になりました！',
        label__tooltip__1__description: 'お客様が必要とするものをなんでも－他社の製品型番の入力も可能です！',
        label__tooltip__2__emphasis: 'パラメーター等で比較！',
        label__tooltip__2__description: '新しいツールで簡単に２製品の違いを見ることができます。',
        label__tooltip__3__emphasis: '記述で検索！',
        label__tooltip__3__description: '何か想定される内容を検索ボックスに入力してください。',
        label__quantity: '数量',
        label__queue__add: '他の製品を追加する',
        message__alert__alreadySelected: 'この値は既に選択されています:{{value}}.',
        message__changeToPart: '製品型番が間違っていると思われます。入力型番 <b>{{originalPart}}</b> を <b>{{changedPart}}</b>に変更しました。',
        message__comparison__confirmation: 'この内容を削除しても構いませんか？１製品のみでは比較できませんので、前の画面にもどります。',
        message__defaultText: '一致する製品が見つかりました。',
        message__errorText: '一致する製品が見つかりませんでした。',
        message__findingAvailability: '製品を探しています',
        message__header__info: '注意事項',
        message__header__error: '検索できません！',
        message__header__default: 'ご注意下さい!',
        message__MODIFIED: 'この製品には仕様変更が含まれています。',
        message__MODIFIED__NON_QUALIFIED: '<strong>ヒント:</strong>"比較して検索"チェックボックスを使って検索結果を比較することができます。',
        message__NON_QUALIFIED: 'この製品はfit/form/functionが一致しません。',
        message__noAvailability: '現在、この製品に関する在庫状況や価格情報はありません。',
        message__obsolete__nnd: '新規設計非推奨品',
        message__obsolete: '廃品種',
        message__overSelection: '４アイテム以上は選択できません。',
        message__plotting__data_error: 'プロット用のデータを取得できませんでした。',
        message__server__rate_limit: 'レート制限を超えました.5分後にもう一度お試しください。',
        message__server__generic: 'サーバーで何か問題が発生しました。',
        modal__bad_browser__confirm: '内容を理解したので続ける。',
        modal__bad_browser__heading_red: '警告：',
        modal__bad_browser__heading: 'サポートされていないブラウザ',
        modal__bad_browser__message: 'ご使用のブラウザは本アプリケーションでは十分にサポートされていません。もしくは動作に問題が発生する場合があります。',
        modal__bad_browser__message__lte_IE_8: 'インターネットエクスプローラー8をご使用して、このメッセージを見れる場合は、互換モードを使用しているとおもわれます。何か質問がある場合は<a href="mailto:timblanks@kemet.com">ティム・ブランクス</a>へお問い合わせ下さい。',
        modal__bad_browser__message__download: 'ご使用のブラウザを最新のものにアップグレードまたは変更すれば全ての機能がご使用可能です。下記ダのロゴのいずれかをクリックしてダウンロードページを表示できます。また既にこれらのうちのいずれかをインストールしている場合は、そのブラウザをご使用いただくようお願いいたします。',
        nav__item__about: 'KEMETについて',
        nav__item__buy: '製品ご購入方法について',
        nav__item__ec: 'Engineering Center',
        nav__item__home: 'Home',
        nav__item__privacy: '個人情報保護',
        nav__item__do_not_sell: 'Cookie Settings',
        nav__item__products: '製品',
        nav__item__search: '製品を検索',
        nav__item__service: 'サポート＆サービス',
        nav__item__software: 'サードパーティー製ソフトウェアについて',
        nav__copyright: `Copyright &copy; ${(new Date().getFullYear())} KEMET. All rights Reserved.`,
        new__label: 'New!',
        plotting__cv_intro_header: 'ビジュアル検索ができます',
        plotting__cv_intro_message: 'この表示内容は、各製品カテゴリが提供する静電容量と最大電圧の範囲を示しています。',
        plotting__cv_instruction_header: '画像検索の使い方',
        plotting__cv_instruction_message_pre: 'ビジュアル検索の使用方法はこちら：',
        plotting__cv_instruction_message_1: '右側の商品カテゴリ名を切り替えることで、ご希望の商品カテゴリデータの表示／非表示が可能です。',
        plotting__cv_instruction_message_2: '製品カテゴリのデータを色分けしたビジュアルエリア内で、データポイントをクリックすると、その静電容量と最大電圧を持つすべての部品を見つけることができます。',
        plotting__cv_instruction_message_3: 'データを拡大するには、グラフ上の領域をクリックしてボックスをドラッグして下さい。',
        plotting__cv_instruction_message_4: '表示された内容の上にあるツールバーを使用して、グラフのズーム、移動、リセット、ＰＮＧ画像のダウンロードが可能です。',
        plotting__cv_instruction_message_5: 'グラフにカーソルを合わせると、マウスに最も近い静電容量と最大電圧のデータポイントが表示されます。',
        search__label: '主要な検索',
        search__placeholder: 'KEMET製品型番/他社製品型番、 仕様等を入力して下さい',
        // -- OPTIONAL - This can be anchor title attributes and image alt tags, and others. Not necessary for launch [03-15-2018 talked to Tim].
        title__GoBackToHome: 'Homeへ戻る',
        title__card__viewCategory: '{{ thisDefinitionName }}の下のカテゴリーを見る',
        title__logo__title: 'KEMET ホームページ',
        title__logo__alt: 'KEMETロゴ',
        title__heading__compare: '{{numberOf}}製品を比較しています',
        visual__search__label: '画像検索',
        visualize__label: '画像検索',
        wizard__home: 'ここからスタート',
        wizard__home2: 'Home',
        wizard__browse: 'ページを見る',
        wizard__viewParts: '製品情報を見る',
        wizard__buyParts: '製品を購入する'
    });
    $translateProvider.translations('de', {});
    $translateProvider.translations('es', {});
    $translateProvider.translations('ko', {});

    $translateProvider.useSanitizeValueStrategy('sce'); // for escaping security
    $translateProvider.preferredLanguage('en');
}
